import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectures } from "../../../../services/dashboard/apiLectures";

export function useLectures({
  courseId,
  filter,
  searchValue,
  include,
  includeFields,
  sortBy,
  perPage,
  page = 1,
  filterAndSortAndPageQuery,
} = {}) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: lectures,
    isSuccess,
  } = useQuery({
    queryKey: [
      "lecturesDashboard",
      page,
      perPage,
      filter,
      searchValue,
      include,
      includeFields,
      sortBy,
      filterAndSortAndPageQuery,
      courseId,
    ],
    queryFn: () =>
      getLectures({
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
        courseId,
      }),
  });
  const totalPages = Math.ceil(
    lectures?.meta?.total / lectures?.meta?.per_page
  );
  // PRE-FETCHING
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "lecturesDashboard",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
        courseId,
      ],
      queryFn: () =>
        getLectures({
          page,
          perPage,
          filter,
          searchValue,
          include,
          includeFields,
          sortBy,
          filterAndSortAndPageQuery,
          courseId,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "lecturesDashboard",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
        courseId,
      ],
      queryFn: () =>
        getLectures({
          page,
          perPage,
          filter,
          searchValue,
          include,
          includeFields,
          sortBy,
          filterAndSortAndPageQuery,
          courseId,
        }),
    });
  }

  return { isPending, lectures };
}
